import { FluentBundle } from "fluent/compat";
import MESSAGES_ALL from "./translate";
import { negotiateLanguages } from "fluent-langneg/compat";

// A generator function responsible for building the sequence
// of FluentBundle instances in the order of user's language
// preferences.


export function* generateBundles(userLocales) {
  // Choose locales that are best for the user.
  const currentLocales = negotiateLanguages(userLocales, ["fr-FR", "es-ES"], {
    defaultLocale: "fr-FR"
  });

  for (const locale of currentLocales) {
    const bundle = new FluentBundle(locale);
    bundle.addMessages(MESSAGES_ALL[locale]);
    yield bundle;
  }
}
